import { isFreeItem } from "components/Basket/utils/freeItemCheck";
import type { DiscountType, ItemType } from "@shared/graphql.types";
import { getDiscountedItemPrice } from "utils/getDiscountedItemPrice";
import { getPriceByType } from "./getPriceByType";

interface OrderSummaryType {
  productMemberTotal: number;
  productTypicalTotal: number;
  membershipMemberTotal: number;
  productGuestTotal: number;
}

const calcPrice = (
  item: ItemType,
  acc: OrderSummaryType,
  userDiscounts: DiscountType[] = []
): OrderSummaryType => {
  const { members, typical, guest } = getPriceByType(item);
  const discountedMemberTotal =
    getDiscountedItemPrice(item, members, userDiscounts) *
    (item?.quantity ?? 1);
  const discountedTypicalTotal =
    getDiscountedItemPrice(item, typical, userDiscounts) *
    (item?.quantity ?? 1);
  const discountedGuestTotal =
    getDiscountedItemPrice(item, guest, userDiscounts) * (item?.quantity ?? 1);
  switch (item?.type) {
    case "product":
      acc.productMemberTotal += discountedMemberTotal;
      acc.productTypicalTotal += discountedTypicalTotal;
      acc.productGuestTotal += discountedGuestTotal;
      break;
    case "membership":
    case "giftMembership":
      acc.membershipMemberTotal += discountedMemberTotal;
      break;
    default:
      return acc;
  }
  return acc;
};

export const getTotalPrices = (
  items: ItemType[] = [],
  userDiscounts: Array<DiscountType> = []
): OrderSummaryType => {
  const init = {
    productMemberTotal: 0,
    productTypicalTotal: 0,
    membershipMemberTotal: 0,
    productGuestTotal: 0
  };

  if (!items?.length) return init;

  const shouldUpdate = (item) => {
    if (isFreeItem(item)) return false;
    return !item.variant || item.variant?.availability?.status !== "outofstock";
  };

  return items.reduce((acc, item) => {
    if (item && shouldUpdate(item)) {
      return calcPrice(item, acc, userDiscounts);
    }
    return acc;
  }, init);
};
